export default __webpack_public_path__ + "3093223a0612d92124b44f5ebf193cc4.jpg";